module.exports = __webpack_public_path__ + "static/media/image17.64efab88.jpg";